import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { IJobArea } from '../models/job-area.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class JobAreaApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/JobAreas`;
  }

  loadJobAreas(currentFilter?: MainTableFilterModel): Observable<ApiResponse<IJobArea[]>> {
    const params = createFilterParams(currentFilter);
    return this.http.get<ApiResponse<IJobArea[]>>(this.url, { params });
  }

  loadJobAreaById(id: string): Observable<IJobArea> {
    return this.http.get<IJobArea>(`${this.url}/${id}`);
  }

  loadAllJobAreas(): Observable<IJobArea[]> {
    const url = `${this.url}/List`;
    return this.http.get<IJobArea[]>(url);
  }

  createJobArea(jobArea: IJobArea): Observable<IJobArea> {
    return this.http.post<IJobArea>(this.url, jobArea, { headers });
  }

  updateJobArea(jobArea: IJobArea): Observable<IJobArea> {
    return this.http.put<IJobArea>(`${this.url}/${jobArea.id}`, jobArea, { headers });
  }

  deleteJobArea(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

  constructor(private http: HttpClient) {}
}
